import {Injectable} from '@angular/core';
import {User} from '../models/user';
import {Observable, of} from 'rxjs';
import {mergeMap, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {AbstractRestService} from '../../services/abstract-rest.service';

@Injectable()
export class AuthService extends AbstractRestService {

    private static USER_TOKEN = 'token';
    private static LOGGED_USER_KEY = 'user';

    constructor(
        private http: HttpClient
    ) {
        super();
    }

    public getToken(): string {
        return localStorage.getItem(AuthService.USER_TOKEN);
    }

    login(username?: string, password?: string): Observable<User> {
        this.logout();
        let token;

        // TODO add real rest api
        return of({token: 'x'})
            // this.http.post<any>(`${this.baseURL}/signin`, {username, password})
            .pipe(
                mergeMap((data: any) => {
                    token = data.token || data.access_token;
                    return this.me(token);
                }),
                tap(() => {
                    localStorage.setItem(AuthService.USER_TOKEN, token);
                })
            );
    }

    me(token?: string): Observable<User> {
        token = token || this.getToken();

        let obs: Observable<User>;

        if (token) {
            // TODO add real rest api
            obs = of({}); // this.http.get<User>(`${this.baseURL}/check-logged-user`);
        } else {
            obs = this.login();
        }

        return obs.pipe(
            tap((user) => {
                    localStorage.setItem(AuthService.LOGGED_USER_KEY, JSON.stringify(user));
                }
            )
        );
    }

    logout(): Observable<boolean> {
        localStorage.removeItem(AuthService.USER_TOKEN);
        localStorage.removeItem(AuthService.LOGGED_USER_KEY);
        return of(true);
    }

}
